module.exports = __webpack_public_path__ + "static/work-at-toggl-57c1123ae6562248754ec1fde3bc657a.jpg";